import React, {useState, useCallback, useEffect} from 'react';
import {useParams, useNavigate, useSearchParams} from 'react-router-dom';
import FormFillerDisplay from './FormFillerDisplay';
import {Helmet} from 'react-helmet';

// 直接使用环境变量
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';
const IMAGES_BASE_URL = process.env.REACT_APP_images_API_BASE_URL || '';

// 将分享图片URL规范化为完整公网URL（微信要求 imgUrl 必须是绝对路径）
const normalizeShareImgUrl = (img) => {
    if (!img) return '';
    if (img.startsWith('http://') || img.startsWith('https://') || img.startsWith('data:')) return img;
    const base = (IMAGES_BASE_URL || window.location.origin).replace(/\/+$/, '');
    return base + (img.startsWith('/') ? img : '/' + img);
};

export default function FormFillerPageDisplay() {
    const {formId} = useParams();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [meta, setMeta] = useState({});
    
    // 获取URL参数中的卡号
    const cardNumber = searchParams.get('cardNumber');

    // 通过ref回传formData
    const handleFormDataLoaded = useCallback((formData) => {
        const wechatShare = formData?.wechatShare || {};
        const newMeta = {
            title: wechatShare.title || formData.formTitle || '表单展示',
            desc: wechatShare.desc || formData.formDesc || '表单展示页面',
            img: normalizeShareImgUrl(wechatShare.img) || normalizeShareImgUrl('/uploads/66bb5010931243e8841309a009d58387.png'),
        };
        setMeta(prev => {
            if (
                prev.title === newMeta.title &&
                prev.desc === newMeta.desc &&
                prev.img === newMeta.img
            ) {
                return prev;
            }
            return newMeta;
        });
    }, []);

    return (
        <>
            <Helmet>
                <title>{meta.title}</title>
                <meta property="og:title" content={meta.title}/>
                <meta property="og:description" content={meta.desc}/>
                <meta property="og:image" content={meta.img}/>
                <meta property="og:type" content="website"/>
                <meta property="og:url" content={window.location.href}/>
                <meta name="wechat-title" content={meta.title}/>
                <meta name="wechat-desc" content={meta.desc}/>
                <meta name="wechat-img" content={meta.img}/>
            </Helmet>
            <div>
                <FormFillerDisplay 
                    formId={formId} 
                    onFormDataLoaded={handleFormDataLoaded}
                    cardNumber={cardNumber}
                />
            </div>
        </>
    );
}
